var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:('--primary: ' + _vm.color)},[_c('v-app',[(_vm.$route.name !== 'Sign')?_c('navbar'):_vm._e(),_c('router-view'),(_vm.$route.name !== '404')?_c('Footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }